import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { StorePriceImportModel } from 'src/app/models/imports/store-price-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { StorePriceModel } from 'src/app/models/subrental/store-price.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StorePriceService {

  private readonly _httpClient = inject(HttpClient);

  createStorePrice(storePriceModel: StorePriceModel): Observable<StorePriceModel> {
    return this._httpClient.post<StorePriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.CreateStorePrice}`,
      storePriceModel);
  }

  deleteStorePrice(storePriceId: number): Observable<StorePriceModel> {
    return this._httpClient.delete<StorePriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.DeleteStorePrice}/${storePriceId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.ExportGeneralConsultation}`,
      filters, { params, responseType: 'blob', });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllStorePricesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.GetAllStorePricesWithPaginationAsync}`,
      filters, { params: params });
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.GetColumnsForGeneralConsultationAsync}`);
  }

  getStorePriceById(storePriceId: number): Observable<StorePriceModel> {
    return this._httpClient.get<StorePriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.GetStorePriceById}/${storePriceId}`);
  }

  getStorePriceByKeys(branchId: number, storeId: number, articleId: number): Observable<StorePriceModel> {
    return this._httpClient.get<StorePriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.GetStorePriceByKeys}/${branchId}/${storeId}/${articleId}`);
  }

  importStorePrices(storePriceImports: Array<StorePriceImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.ImportStorePrices}`, storePriceImports);
  }

  updateStorePrice(storePriceModel: StorePriceModel): Observable<StorePriceModel> {
    return this._httpClient.put<StorePriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.storePrice.UpdateStorePrice}`, storePriceModel);
  }

}
